var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ColorPicker"},[_c('div',{staticClass:"ColorPicker-Label text-first-uppercase"},[_vm._v(_vm._s(_vm.$t(_vm.label)))]),_c('div',{staticClass:"ColorPicker-Picker"},[_c('div',{ref:"pickr",staticClass:"pickr"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }